import React from "react";
import GetPatients from "./GetPatients";
import Header from "./Header";
export default function Controls() {
  document.title = "Mange Patients";
  return (
    <div>
      <Header />
      <GetPatients />
    </div>
  );
}
